export default __webpack_public_path__ + "static/media/avatar_placeholder_2.676e7245.jpg";